﻿import $ from "jquery";

export default (parameter) => {
    var qd = {};
    $(location.search.toLowerCase().substr(1).split("&"))
        .each(function(item, el) {
            (el.split("=")[0] in qd)
                ? qd[el.split("=")[0]].push(el.split("=")[1])
                : qd[el.split("=")[0]] = [el.split("=")[1]];
        });
    var response = (typeof (qd[parameter]) !== "undefined") ? qd[parameter][0] : "";
    return response;
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/utils/getUrlParameter.js
// module id = 2
// module chunks = 2 3